import { ViewChild, Component, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../utils/helper';
import { PinComponent } from './pin/pin.component';
import { ToastBarService } from '../../../services/toast-bar.service';

@Component({
  selector: 'app-base',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class BaseComponent {
  public helper = Helper; // Expose the Helper class to derived components
  @ViewChild(PinComponent) pinComponent!: PinComponent;

  constructor(protected toastBarService: ToastBarService) { }
}
